import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IUser } from 'app/shared/Domains/IUser';
import { IMember } from 'app/shared/Domains/member';
import { IPackageBuider } from 'app/shared/Domains/packageBuilder';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import * as fs from 'file-saver';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
  selector: 'app-export-data',
  templateUrl: './export-data.component.html',
  styleUrls: ['./export-data.component.css']
})
export class ExportDataComponent implements OnInit {
  user: IUser;
  branchAndCompany: any;
  dialogVisibility: any;
  packages: IPackageBuider[] = [];
  loading: boolean;
  @Output() closeExportingDialog = new EventEmitter<any>();

  constructor(private LanguageService: LanguageService, private appServiceManager: AppServiceManager, private messageService: MessageService) { }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("ExportDataComponent", label);
  }
  ngOnInit() {
    this.dialogVisibility = true;
    this.loading = false;
    this.user = new IUser();
    this.user = AuthService.getLoggedInUser();
    this.branchAndCompany = {
      branch: this.user.branch,
      company: this.user.company
    }
    this.getAllPackages();
  }

  getAllPackages() {
    this.packages = [];
    //this.loading = true;
    this.appServiceManager.get('packagesBuilder/company/' + this.user.company).subscribe((res) => {
      this.packages = res;
      // this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  async getAllData() {
    this.loading = true;
    let exportFlag=true;
    let apiUrl = `customers/company/${this.user.company}/branch/${this.user.branch}/short?exportFlag=${exportFlag}`;
    let membersAndFeePromise = await this.appServiceManager.get(apiUrl).toPromise();
    let trainersPromise = await this.appServiceManager.get('Trainers/company/' + this.user.company + '/branch/' + this.user.branch).toPromise();
    let visitorAndFeePromise = await this.appServiceManager.post('visitors/search', this.branchAndCompany).toPromise();
    let userPromise = await this.appServiceManager.post('users/search', this.branchAndCompany).toPromise();

    let membersAndFee = await this.getMembers(membersAndFeePromise); // Member = membersAndFee[0] & Fee = membersAndFee[1]
    let trainers = await this.getTrainers(trainersPromise);
    let visitorAndFee = await this.getVisitors(visitorAndFeePromise); // visitor = visitorAndFee[0] & Fee = visitorAndFee[1]
    let user = await this.getUsers(userPromise);

    console.log("membersAndFee", membersAndFee, "trainers", trainers, "visitorAndFee", visitorAndFee, "user", user);
    this.exportExcel(membersAndFee, trainers, visitorAndFee, user);
  }

  getMembers(membersAndFeePromise) {
    if (membersAndFeePromise.length > 0) {
      let list = [];
      let feeList = [];
      let i = 1;
      membersAndFeePromise.forEach(member => {
        var obj = {
          // No: i,
          MemberShipNo: member.tagNumber,
          Name: member.name || "",
          CNIC: member.CNIC || "",
          Package: this.getPackageName(member.packageId),
          Contact: member.contactDetail.contact,
          Comment: member.description,
          Profession: member.profession ? member.profession : "",
          Email: member.email ? member.email : "",
          JoiningDate: new Date(member.joiningDate).toLocaleDateString(),
          RegisterationFee: member.registerationFee || "",
          MontlyFee: member.monthFee,
          TrainingFee: member.customerstrainer ? member.customerstrainer.totalFees:" ",
          TrainerName: member.customerstrainer ? member.customerstrainer.name : "",
          Street: member.contactDetail.address ? member.contactDetail.address.street ? member.contactDetail.address.street : "" : "",
          City: member.contactDetail.address ? member.contactDetail.address.city ? member.contactDetail.address.city : "" : "",
          Country: member.contactDetail.address ? member.contactDetail.address.country ? member.contactDetail.address.country : "" : "",
          Gender: member.gender ? member.gender : "",
          isDelete: member.isDelete,
          _id:member._id,
          company:member.company,
          branch:member.branch
        }
        list.push(obj);
        i++;
        if (member.feeDetails.length > 0) {
          member.feeDetails.map((fee: {_id:any;invoice: any; pay: any; status: any; date: any; }) => {
            var obj = {
              MemberName: member.name,
              Invoice: fee.invoice,
              Pay: fee.pay,
              Status: fee.status,
              Date: fee.date,
              MemberShipNo: member.tagNumber,
              _id:fee._id,

            };
            feeList.push(obj);
          });
        }
      });
      return [list, feeList];
    } else {
      return [];
    }
  }

  getTrainers(trainersPromise) {
    if (trainersPromise.length > 0) {
      let list = [];
      let i = 1;
      trainersPromise.forEach(traine => {
        let trainerSkill = '';
        traine.selectedSkills.map((ss, index) => {
          if (index == 0) {
            trainerSkill += ss.skillName
          }
          else {
            trainerSkill += "," + ss.skillName
          }
        })
        var obj = {
          // No: i,
          TraineNo: traine.trainerCode,
          Name: traine.name,
          DateOfBirth: traine.dateOfBirth ? traine.dateOfBirth : "",
          Contact: traine.contact,
          Gender: traine.gender,
          TotalFees: traine.totalFees,
          GymShare: traine.gymShare,
          TrainerShare: traine.trainerShare,
          SelectedSkills: trainerSkill,
          _id: traine._id
        }
        list.push(obj);
        i++;
      });
      return list;
    } else {
      return [];
    }
  }

  getVisitors(visitorAndFeePromise) {
    if (visitorAndFeePromise.length > 0) {
      let list = [];
      let feeList = [];
      visitorAndFeePromise.forEach(visitor => {
        var obj = {
          // No: i,
          Name: visitor.name,
          DateOfBirth: visitor.dateOfBirth ? visitor.dateOfBirth : "",
          Email: visitor.email ? visitor.email : "",
          Gender: visitor.gender ? visitor.gender : "",
          Contact: visitor.phone,
          _id:visitor._id
        }
        list.push(obj);
        if (visitor.feeDetails.length > 0) {
          visitor.feeDetails.map(fee => {
            var obj = {
              MemberName: visitor.name,
              Invoice: fee.invoice,
              Pay: fee.pay,
              Status: fee.status,
              Date: fee.date,
              _id:visitor._id
            };
            feeList.push(obj);
          });
        }
      });
      return [list, feeList];
    } else {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      return [];
    }
  }

  async getUsers(user) {
    if (user.length > 0) {
      let list = [];
      user.forEach(user => {
        var obj = {
          // No: i,
          UserNo: user.userCode,
          Name: user.name,
          DateOfBirth: user.dateOfBirth ? user.dateOfBirth : "",
          Email: user.email,
          Phone: user.phone,
          Role:"Admin",
          _id:user._id,
          company:user.company,
          branch:user.branch

        }
        list.push(obj);
      });
      return list;
    } else {
      return [];
    }
  }

  getPackageName(id) {
    let memberPackage = this.packages.filter(p => p._id == id);
    if (memberPackage.length > 0) {
      return memberPackage[0].packageName;
    }
    return "";
  }

  exportExcel(membersAndFee, trainers, visitorAndFee, user) {
    import("xlsx").then(xlsx => {
      var wb = xlsx.utils.book_new();
      //member sheet
      var memberWs = xlsx.utils.json_to_sheet(membersAndFee[0]);
      xlsx.utils.book_append_sheet(wb, memberWs, "Members");
      //member fee sheet
      var memberFeeWs = xlsx.utils.json_to_sheet(membersAndFee[1]);
      xlsx.utils.book_append_sheet(wb, memberFeeWs, "Members Fee");
      //trainers sheet
      var trainersWs = xlsx.utils.json_to_sheet(trainers);
      xlsx.utils.book_append_sheet(wb, trainersWs, "Trainers");
      //visitor sheet
      var visitorsWs = xlsx.utils.json_to_sheet(visitorAndFee[0]);
      xlsx.utils.book_append_sheet(wb, visitorsWs, "Visitors");
      //visitor fee sheet
      var visitorsFeeWs = xlsx.utils.json_to_sheet(visitorAndFee[1]);
      xlsx.utils.book_append_sheet(wb, visitorsFeeWs, "Visitors Fee");
      //user sheet
      var userWs = xlsx.utils.json_to_sheet(user);
      xlsx.utils.book_append_sheet(wb, userWs, "Users");

      const excelBuffer: any = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "All_Data");
    });
  }

  exportDailyClosingReportExcel(feeCollected, posSales, pettyExpenses, purchaseHistory, summary, name) {
    import("xlsx").then(xlsx => {
      var wb = xlsx.utils.book_new();
      //Fee Collected sheet
      var feeCollectedWs = xlsx.utils.json_to_sheet(feeCollected);
      xlsx.utils.book_append_sheet(wb, feeCollectedWs, "Fee Collected");
      //POS Sales sheet
      var posSalesWs = xlsx.utils.json_to_sheet(posSales);
      xlsx.utils.book_append_sheet(wb, posSalesWs, "POS Sales");
      //Petty Expenses sheet
      var pettyExpensesWs = xlsx.utils.json_to_sheet(pettyExpenses);
      xlsx.utils.book_append_sheet(wb, pettyExpensesWs, "Petty Expenses");
      //Purchase History fee sheet
      var purchaseHistoryWs = xlsx.utils.json_to_sheet(purchaseHistory);
      xlsx.utils.book_append_sheet(wb, purchaseHistoryWs, "Purchase History");
      //Summary sheet
      var summaryWs = xlsx.utils.json_to_sheet([summary]);
      xlsx.utils.book_append_sheet(wb, summaryWs, "Summary");

      const excelBuffer: any = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, name);
    });
  }

  ExportDataReports(reports,summary,name) {
    console.log("reports", reports)

    import("xlsx").then(xlsx => {
      var wb = xlsx.utils.book_new();
      //sales sheet
      var reportsWs = xlsx.utils.json_to_sheet(reports);
      xlsx.utils.book_append_sheet(wb, reportsWs, "Reports");

      // summary sheet
      var summaryWs = xlsx.utils.json_to_sheet([summary]);
      xlsx.utils.book_append_sheet(wb, summaryWs, "Summary");

      const excelBuffer: any = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, name);
    });
  }
  ExportDataBirthdayReports(reports,name) {
    console.log("reports", reports)

    import("xlsx").then(xlsx => {
      var wb = xlsx.utils.book_new();
      var reportsWs = xlsx.utils.json_to_sheet(reports);
      xlsx.utils.book_append_sheet(wb, reportsWs, "Reports");

      const excelBuffer: any = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, name);
    });
  }

  ExportDataEnquiries(enquiries,name) {
    console.log("enquiries", enquiries)

    import("xlsx").then(xlsx => {
      var wb = xlsx.utils.book_new();
      //enquiries sheet
      var reportsWs = xlsx.utils.json_to_sheet(enquiries);
      xlsx.utils.book_append_sheet(wb, reportsWs, "Enquiries");

      const excelBuffer: any = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, name);
    });
  }

  ExportDataVisitors(visitors,name) {
    console.log("visitors", visitors)

    import("xlsx").then(xlsx => {
      var wb = xlsx.utils.book_new();
      //visitors sheet
      var reportsWs = xlsx.utils.json_to_sheet(visitors);
      xlsx.utils.book_append_sheet(wb, reportsWs, "Visitors");

      const excelBuffer: any = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, name);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const members: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    fs.saveAs(members, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
    this.closeExportingDialog.emit();
  }

  onBeforeDialogHide() {
    this.closeExportingDialog.emit();
  }
}
